import React, { useContext } from 'react';
import { IActInfo } from '../../component';
import { formatImage } from '../../utils/util';
import ReactSVG from 'react-svg';
import intl from 'react-intl-universal';
import './ActInfo.scss';

import { ThemeContext } from '../../store/ThemeProvider';

const ActFlow = function(props: IActInfo) {
  const { content, edittype } = props;
  const themeContext = useContext(ThemeContext);
  const showMap = () => {
    window.wx.openLocation({
      latitude: content.map.latitude, // 纬度，浮点数，范围为90 ~ -90
      longitude: content.map.longitude, // 经度，浮点数，范围为180 ~ -180。
      name: content.map.name, // 位置名
      scale: 16
    });
  };

  return (
    <div className="actinfo">
      {content.time ? (
        <div className="actinfo-row">
          <div className="title" style={{ color: themeContext.h1Color }}>
            <ReactSVG
              src={require('../../svg/double-triangle.svg')}
              className={'i'}
              style={{ fill: themeContext.mainColor }}
            />
            {intl.get('Time')}
          </div>
          <div className="content" style={{ color: themeContext.h2Color }}>
            {content.time}
          </div>
        </div>
      ) : null}
      {content.map && content.map.name ? (
        <div className="actinfo-row">
          <div className="title" style={{ color: themeContext.h1Color }}>
            <ReactSVG
              src={require('../../svg/double-triangle.svg')}
              className={'i'}
              style={{ fill: themeContext.mainColor }}
            />
            {intl.get('Place')}
          </div>
          <div className="content" style={{ color: themeContext.h2Color }}>
            {content.map.name}
            {content.map.latitude || content.map.longitude ? (
              <img
                onClick={showMap}
                src={formatImage(
                  `/map/${content.map.latitude}_${content.map.longitude}.jpg`,
                  'original'
                )}
              />
            ) : null}
          </div>
        </div>
      ) : null}
      {content.sponsor ? (
        <div className="actinfo-row">
          <div className="title" style={{ color: themeContext.h1Color }}>
            <ReactSVG
              src={require('../../svg/double-triangle.svg')}
              className={'i'}
              style={{ fill: themeContext.mainColor }}
            />
            {intl.get('organizer')}
          </div>
          <div className="content" style={{ color: themeContext.h2Color }}>
            {content.sponsor}
          </div>
        </div>
      ) : null}
      {content.detail ? (
        <div className="actinfo-row">
          <div className="title" style={{ color: themeContext.h1Color }}>
            <ReactSVG
              src={require('../../svg/double-triangle.svg')}
              className={'i'}
              style={{ fill: themeContext.mainColor }}
            />
            {intl.get('Introduction')}
          </div>
          <div className="content" style={{ color: themeContext.h2Color }}>
            {(content.detail || '')
              .split(/\n/gi)
              .map((it: string, index: number) => {
                return <p key={`${it}${index}`}>{it}</p>;
              })}
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default ActFlow;
